shadow$provide[241] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Scale:{enumerable:true, get:function() {
  return Scale;
}}});
var UAxis = require("../../../util/axis.js");
var require$_DOT__DOT__SLASH_base_SLASH_source_DOT_js = require("../base/source.js");
class Scale extends require$_DOT__DOT__SLASH_base_SLASH_source_DOT_js.Source {
  static initClass() {
    this.traits = ["node", "source", "index", "interval", "span", "scale", "raw", "origin",];
  }
  init() {
    return this.used = this.space = this.scaleAxis = this.sampler = null;
  }
  rawBuffer() {
    return this.buffer;
  }
  sourceShader(shader) {
    return shader.pipe(this.sampler);
  }
  getDimensions() {
    return {items:1, width:this.space, height:1, depth:1,};
  }
  getActiveDimensions() {
    return {items:1, width:this.used, height:this.buffer.getFilled(), depth:1,};
  }
  getRawDimensions() {
    return this.getDimensions();
  }
  make() {
    let samples;
    this.space = samples = this._helpers.scale.divide("");
    this.buffer = this._renderables.make("dataBuffer", {width:samples, channels:1, items:1,});
    const positionUniforms = {scaleAxis:this._attributes.make(this._types.vec4()), scaleOffset:this._attributes.make(this._types.vec4()),};
    this.scaleAxis = positionUniforms.scaleAxis.value;
    this.scaleOffset = positionUniforms.scaleOffset.value;
    const p = this.sampler = this._shaders.shader();
    p.require(this.buffer.shader(this._shaders.shader(), 1));
    p.pipe("scale.position", positionUniforms);
    this._helpers.span.make();
    return this._listen(this, "span.range", this.updateRanges);
  }
  unmake() {
    this.scaleAxis = null;
    return this._helpers.span.unmake();
  }
  change(changed, touched, init) {
    if (changed["scale.divide"]) {
      return this.rebuild();
    }
    if (touched["view"] || touched["interval"] || touched["span"] || touched["scale"] || touched["origin"] || init) {
      return this.updateRanges();
    }
  }
  updateRanges() {
    const {used} = this;
    const {axis, origin} = this.props;
    const range = this._helpers.span.get("", axis);
    const min = range.x;
    const max = range.y;
    const ticks = this._helpers.scale.generate("", this.buffer, min, max);
    UAxis.setDimension(this.scaleAxis, axis);
    UAxis.setOrigin(this.scaleOffset, axis, origin);
    this.used = ticks.length;
    if (this.used !== used) {
      return this.trigger({type:"source.resize",});
    }
  }
}
Scale.initClass();

};